import Vue from 'vue'

const hasOwnProperty = Object.prototype.hasOwnProperty

export const isFirefox = function () {
  return !Vue.prototype.$isServer && !!window.navigator.userAgent.match(/firefox/i)
}

export function rafThrottle (fn) {
  let locked = false
  return function (...args) {
    if (locked) return
    locked = true
    window.requestAnimationFrame(_ => {
      fn.apply(this, args)
      locked = false
    })
  }
}

export function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
};
